var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFechar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fechar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.797,
    height: 23.828,
    viewBox: "0 0 23.797 23.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_191",
    "data-name": "Caminho 191",
    d: "M128.787,151.5a1.648,1.648,0,0,0,1.168.5,1.6,1.6,0,0,0,1.168-.5l9.068-9.068,9.068,9.068a1.648,1.648,0,0,0,1.168.5,1.6,1.6,0,0,0,1.168-.5,1.7,1.7,0,0,0,0-2.364l-9.04-9.04,9.04-9.068a1.7,1.7,0,0,0,0-2.364,1.67,1.67,0,0,0-2.364,0l-9.04,9.068-9.068-9.04a1.672,1.672,0,1,0-2.364,2.364l9.068,9.04-9.04,9.068A1.613,1.613,0,0,0,128.787,151.5Z",
    transform: "translate(-128.279 -128.173)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFechar);
export default __webpack_public_path__ + "static/media/fechar.e201e2f8099d4e726ee929d17ba8e381.svg";
export { ForwardRef as ReactComponent };